module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumeEditor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resume.config), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }))]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resume.config), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field === selected"
      }]
    }, [(_vm.resume[item.field] instanceof Array) ? _c('div', _vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, [_vm._l((subitem), function(value, key) {
        return _c('div', {
          staticClass: "resumeField"
        }, [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              _vm.changeResumeField(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), _c('hr')], 2)
    })) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            _vm.changeResumeField(((item.field) + "." + key), $event.target.value)
          }
        }
      })])
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.1@vue-loader/lib/template-compiler?{"id":"data-v-694a504f"}!./~/_vue-loader@12.2.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumeEditor.vue
// module id = 83
// module chunks = 1